import React, { Component } from 'react';

import get from 'lodash/get';
import head from 'lodash/head';
import includes from 'lodash/includes';
import cloneDeep from 'lodash/cloneDeep';
import PropTypes from 'prop-types';
import Masonry from 'react-masonry-component';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import uberFacts from '../../../../assets/usageTips/tips.json';
import LottieLoader from '../../../../components/ui/lotties/LottieLoader';
import OffsetLoadMoreButton from '../../../../components/ui/pagination/OffsetLoadMoreButton';
import * as feedDuck from '../feedDuck';

import FeedResult from './FeedResult';

const sbFeed = {
  post_id: 1,
  post_title: 'Learn more about Steppingblocks in this short video.',
  post_description: 'Watch this brief intro video to find out what you can do with Steppingblocks!',
  source_url: 'https://www.youtube.com/watch?v=5LxmhWPq02E&feature=youtu.be',
  source_code: 'https://www.youtube.com/embed/5LxmhWPq02E',
  is_repeat: false,
  credit_person: 'www.steppingblocks.com',
}

class FeedWrapper extends Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    isNoData: PropTypes.bool,
    isNoLoadMoreData: PropTypes.bool,
    page: PropTypes.number.isRequired,
    onLoadMore: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired,
    readItem: PropTypes.func.isRequired,
    results: PropTypes.array.isRequired,
    searchError: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this.state = {
      playingVideoId: null,
    }

    this.playVideo = playingVideoId => this.setState({ playingVideoId })
  }

  render() {
    const {
      isLoading,
      page,
      onLoadMore,
      openModal,
      results,
      isNoData,
      isNoLoadMoreData,
      searchError,
      readItem,
    } = this.props
    const { playingVideoId } = this.state
    const masonryOptions = {
      transitionDuration: 1000,
    }

    const finalFeedItems = cloneDeep(results)

    if (!includes(get(head(finalFeedItems), 'post_title'), 'Steppingblocks')) {
      finalFeedItems.unshift(sbFeed)
    }

    const initialSearchError = results && results.length === 0 && searchError ? searchError : null

    return (
      <div style={{ margin: '0 -10px' }}>
        <Masonry
          className={'my-gallery-class'} // default ''
          elementType={'div'} // default 'div'
          options={masonryOptions} // default {}
          disableImagesLoaded={false} // default false
          updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
        >
          {finalFeedItems.map((result, index) => {
            const itemId = result.post_id ? result.post_id : `${result.post_title}-${result.userId}`

            return  (
            <FeedResult
              result={result}
              position={index}
              itemId={itemId}
              playingVideoId={playingVideoId}
              key={itemId}
              playVideo={this.playVideo}
              onClick={() => {
                readItem(itemId)
                openModal(result)
                }}
              />
            )})}
        </Masonry>
        <LottieLoader
          isReady={!isLoading || results.length > 0}
          animationName="GEARS"
          error={initialSearchError}
          noData={isNoData}
          noMessage
          uberFacts={uberFacts}
          height={500}
          width={300}
          loadingLottieDivMarginTop={-160}
        >
          <OffsetLoadMoreButton
            isLoading={isLoading}
            noLoadMoreData={isNoLoadMoreData}
            onClick={() => onLoadMore(page + 1)}
            searchError={searchError}
            loadMoreText="Feed Me!"
          />
        </LottieLoader>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      openModal: feedDuck.openModal,
      readItem: feedDuck.performReadFeedItem,
    },
    dispatch,
  )

export default connect(null, mapDispatchToProps)(FeedWrapper)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Dashboard/components/FeedWrapper.js